import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Load the plugins
dayjs.extend(utc);
dayjs.extend(timezone);

// Define the CST timezone string
const CST_TIMEZONE = localStorage.getItem('timeZone');

export const formatCST = (date) => {
    return dayjs.utc(date).tz(CST_TIMEZONE);
};

export const formatDateCST = (date) => {
    return formatCST(date).format("MM/DD/YYYY");
};

export const formatTimeCST = (date) => {
    return formatCST(date).format("h:mm A");
};


export const formatDate = (date) => {
    if (typeof date === 'string') {
        // If the input is a date string, split it and create a Date object
        const dateParts = date.split('-');
        date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
    }

    const formattedDate = date?.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).replace(/-/g, '/');

    return formattedDate;
};

// using this for disburse report modal date table
export const formattedDate = (value) => {
    const date = new Date(value);

    const formattedDate = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(date);

    return formattedDate;
};

export const formatTime = (value) => {
    const date = new Date(value);

    const formattedTime = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    }).format(date);

    return formattedTime;
};

// Format number as money with 2 decimal places and dollar sign
export const formatMoney = (value) => {
    return `$${parseFloat(value)?.toFixed(2).toLocaleString()}`;
};

// Format currency with commas and dollar sign
export const formatCurrencyWithCommas = (number, minFractionDigits = 0, maxFractionDigits = 2) => {
    if (number) {
        const formattedValue = number.toLocaleString(undefined, {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: minFractionDigits,
            maximumFractionDigits: maxFractionDigits,
        });
        return formattedValue;
    } else {
        return '0.00'
    }
};

// Create a function that formats the input
export const formatPhoneNumber = (phoneNumber) => {
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (match) {
        const part1 = match[1];
        const part2 = match[2];
        const part3 = match[3];
        let formattedPhoneNumber = '';
        if (part1) {
            formattedPhoneNumber += '(' + part1;
        }
        if (part2) {
            formattedPhoneNumber += ") " + part2;
        }
        if (part3) {
            formattedPhoneNumber += "-" + part3;
        }
        return formattedPhoneNumber;
    }
    return '';
}

// Create a function that removes non-digits
export const cleanPhoneNumber = (phoneNumber) => {
    return phoneNumber.replace(/\D/g, '');
}

export function AddValueAndLabel(fetchedData = [], firstValue, secondValue) {
    const updatedList = fetchedData?.map((item) => ({
        value: item[firstValue]?.toString(),
        label: item[secondValue]?.toString(),
    }));
    return updatedList;
}

export const toTitleCase = (str) => str.toLowerCase().replace(/(?:^|\s)\w/g, (match) => match.toUpperCase());

export const monthOptions = [
    { value: '01', label: '01' },
    { value: '02', label: '02' },
    { value: '03', label: '03' },
    { value: '04', label: '04' },
    { value: '05', label: '05' },
    { value: '06', label: '06' },
    { value: '07', label: '07' },
    { value: '08', label: '08' },
    { value: '09', label: '09' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' },
];

export const monthToString = [
    { 0: 'JANUARY' },
    { 1: 'FEBRUARY' },
    { 2: 'MARCH' },
    { 3: 'APRIL' },
    { 4: 'MAY' },
    { 5: 'JUNE' },
    { 6: 'JULY' },
    { 7: 'AUGUST' },
    { 8: 'SEPTEMBER' },
    { 9: 'OCTOBER' },
    { 10: 'NOVEMBER' },
    { 11: 'DECEMBER' },
];

//export const monthToStringObj = {
//    1: 'JANUARY',
//    2: 'FEBRUARY',
//    3: 'MARCH',
//    4: 'APRIL',
//    5: 'MAY',
//    6: 'JUNE',
//    7: 'JULY',
//    8: 'AUGUST',
//    9: 'SEPTEMBER',
//    10: 'OCTOBER',
//    11: 'NOVEMBER',
//    12: 'DECEMBER',
//};


export const frequencyOptions = {
    1: 'ONE',
    2: 'TWO',
    3: 'THREE',
    4: 'FOUR',
    5: 'FIVE',
    6: 'SIX',
    7: 'SEVEN',
    8: 'EIGHT',
    9: 'NINE',
    10: 'TEN',
    11: 'ELEVEN',
    12: 'TWELVE',
    13: 'THIRTEEN',
    14: 'FOURTEEN',
    15: 'FIFTEEN',
    16: 'SIXTEEN',
    17: 'SEVENTEEN',
    18: 'EIGHTEEN',
    19: 'NINETEEN',
    20: 'TWENTY',
};

// array of all of the state options for the state dropdown input
export const stateOptions = [
    { value: "AL", label: "AL", hidden: '**' },
    { value: "AK", label: "AK", hidden: '**' },
    { value: "AZ", label: "AZ", hidden: '**' },
    { value: "AR", label: "AR", hidden: '**' },
    { value: "CA", label: "CA", hidden: '**' },
    { value: "CO", label: "CO", hidden: '**' },
    { value: "CT", label: "CT", hidden: '**' },
    { value: "DE", label: "DE", hidden: '**' },
    { value: "FL", label: "FL", hidden: '**' },
    { value: "GA", label: "GA", hidden: '**' },
    { value: "HI", label: "HI", hidden: '**' },
    { value: "ID", label: "ID", hidden: '**' },
    { value: "IL", label: "IL", hidden: '**' },
    { value: "IN", label: "IN", hidden: '**' },
    { value: "IA", label: "IA", hidden: '**' },
    { value: "KS", label: "KS", hidden: '**' },
    { value: "KY", label: "KY", hidden: '**' },
    { value: "LA", label: "LA", hidden: '**' },
    { value: "ME", label: "ME", hidden: '**' },
    { value: "MD", label: "MD", hidden: '**' },
    { value: "MA", label: "MA", hidden: '**' },
    { value: "MI", label: "MI", hidden: '**' },
    { value: "MN", label: "MN", hidden: '**' },
    { value: "MS", label: "MS", hidden: '**' },
    { value: "MO", label: "MO", hidden: '**' },
    { value: "MT", label: "MT", hidden: '**' },
    { value: "NE", label: "NE", hidden: '**' },
    { value: "NV", label: "NV", hidden: '**' },
    { value: "NH", label: "NH", hidden: '**' },
    { value: "NJ", label: "NJ", hidden: '**' },
    { value: "NM", label: "NM", hidden: '**' },
    { value: "NY", label: "NY", hidden: '**' },
    { value: "NC", label: "NC", hidden: '**' },
    { value: "ND", label: "ND", hidden: '**' },
    { value: "OH", label: "OH", hidden: '**' },
    { value: "OK", label: "OK", hidden: '**' },
    { value: "OR", label: "OR", hidden: '**' },
    { value: "PA", label: "PA", hidden: '**' },
    { value: "RI", label: "RI", hidden: '**' },
    { value: "SC", label: "SC", hidden: '**' },
    { value: "SD", label: "SD", hidden: '**' },
    { value: "TN", label: "TN", hidden: '**' },
    { value: "TX", label: "TX", hidden: '**' },
    { value: "UT", label: "UT", hidden: '**' },
    { value: "VT", label: "VT", hidden: '**' },
    { value: "VA", label: "VA", hidden: '**' },
    { value: "WA", label: "WA", hidden: '**' },
    { value: "WV", label: "WV", hidden: '**' },
    { value: "WI", label: "WI", hidden: '**' },
    { value: "WY", label: "WY", hidden: '**' },
];

export const Filters = [
    {
        value: 'NONE',
        label: 'None',
    },
    {
        value: 'BOND',
        label: 'Bond',
    },
    {
        value: 'CRIMINAL',
        label: 'Criminal',
    },
    {
        value: 'TRAFFIC',
        label: 'Traffic',
    }
];

export const GLFilters = [
    {
        value: 'NONE',
        label: 'None',
    },
    {
        value: 'COLLECTIONS',
        label: 'Collections (Deposits)',
    },
    {
        value: 'DISBURSEMENTS',
        label: 'Disbursements'
    }
]

export const PaymentTypeOptions = [
    {
        value: 'none',
        label: 'All',
    },
    {
        value: 'CASH',
        label: 'Cash',
    },
    {
        value: 'CREDIT CARD',
        label: 'Credit Card',
    },
    {
        value: 'CHECK',
        label: 'Check',
    },
    {
        value: 'MONEY ORDER',
        label: 'Money Order',
    }
];

export const TransactionTypeOptions = [
    {
        value: 'CASH BOND',
        label: 'Cash Bond'
    },
    {
        value: 'REFUND',
        label: 'Refund'
    },
    {
        value: 'TIME SERVED',
        label: 'Time Served'
    }
]

export const commaMoneyFormat = (value) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(value);
};

export function not(a, b) {
    return a.filter((value) => b.indexOf(value) === -1);
};

export function intersection(a, b) {
    return a.filter((value) => b.indexOf(value) !== -1);
};

export function union(a, b) {
    return [...a, ...not(b, a)];
};

// convert from UTC to any timezone based on the offset up or down
// format like MMddYYYY, 00:00:00 AM/PM for american timezones
// will format for the locale with undefined param, infers from the browser
export function newIntlDateTimeFormat(value) {
    const date = new Date(value);
    const timezoneOffset = date.getTimezoneOffset();

    const adjustedTime = timezoneOffset > 0
        ?
        new Date(date.getTime() - (timezoneOffset * 60000))
        :
        new Date(date.getTime() + (timezoneOffset * 60000));

    return (
        new Intl.DateTimeFormat(undefined, {
            hour12: true,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
        })
            .format(adjustedTime)
    )

};